import { Button, Col, Flex, Popconfirm, Row, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import { API_ROUTE } from '../../../utils/commonConstants';
import { GET } from '../../../utils/requestActionConstants';
import { fetcher } from '../../../helpers/processRequest';
import useSWR from 'swr';
import { notificationTabConfig } from '../NotificationsTab';
import { useDispatch, useSelector } from 'react-redux';
import { setNotifications, setNotification, updateNotification } from '../../../store/slices/notificationSlice';
import SearchComponent from '../../../components/SearchComponent';
import { STATUS } from '../../../utils/configConstants';
import CsvLink from 'react-csv-export';
import PDFListDownloader from '../../../components/PDFListDownloader';


function NotificationList({ onSwitchTab }) {
  const dataFetcher = useSWR({ method: GET, url: API_ROUTE + '/notifications' }, fetcher);
  const state = useSelector(state => state.notificationSlice);
  const dispatch = useDispatch();
  const [filteredData, setFilteredData] = useState([]);

  const edit = (data) => {
    dispatch(setNotification(data))
    onSwitchTab(notificationTabConfig.ADD, data);
  }

  useEffect(() => {
    if (dataFetcher.data?.data) {
      dispatch(setNotifications(dataFetcher.data.data));
    }
  }, [dataFetcher.data?.data])

  const onDeleteRecord = (record) => {
    dispatch(updateNotification({ notificationId: record.id, notificationData: { status: STATUS.DELETED } }));
  }

  const columns = [
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <>
          <div>
            <Button onClick={() => edit(record)}>Amend</Button>
            <Popconfirm title="Delete" description="Are you sure to delete this record?" onConfirm={() => onDeleteRecord(record)}
              okText="Yes"
              cancelText="No"
            >
              <Button danger type='primary'>Delete</Button>
            </Popconfirm>
          </div>
        </>
      )
    }
  ];

  const pdfDownloadColumns = [
    { key: "id", label: "ID" },
    { key: "title", label: "Title" },
    { key: "description", label: "Description" },
    { key: "status", label: "Status" },
  ];

  const onFilter = (filteredData) => {
    setFilteredData(filteredData);
  }

  return (
    <Row gutter={[16, 16]}>
      <Flex justify='space-between' className='w-full pr-3'>
        <SearchComponent masterData={state.notificationList} onFilter={onFilter} filterByKeys={['title', 'description', 'status']} />
        <Flex content='center'>
          <CsvLink data={state.notificationList} fileName="weda_arana_data" withTimeStamp>
            <div className='text-right text-lg'><Button>CSV</Button></div>
          </CsvLink>
          <PDFListDownloader records={state.notificationList} columns={pdfDownloadColumns} />
        </Flex>
      </Flex>
      <Col span={24}>
        <div>
          <Table columns={columns} dataSource={filteredData} pagination={false} loading={dataFetcher.isLoading} />
        </div>
      </Col>
    </Row>
  );
}

export default NotificationList